module.exports = __webpack_public_path__ + "img/iconAlert.7dcdf9eb.svg";